import Button from "../../components/common/button/Button";
import React, {useEffect, useState} from "react";
import SubHeader from "../../components/header/SubHeader";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {fetchCustomerPayments} from "../../store/customer-slice";
import {fromCamelCaseToTitle} from "../../components/Utility";
import CustomerTransactionCard from "../../components/customer/CustomerTransactionCard";

const CustomerTransactions = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);

    //make date format compatible with date input
    const [formData, setFormData] = useState({
        start: '',
        end: '',
    });

    //Basic Form error
    const [errors, setErrors] = useState({
        start: '',
        end: ''
    });

    const {
        customerPayments,
        fetchCustomerPaymentStatus,
        dateRange,
        error,
    } = useSelector((state) => state.customer);

    const validateField = (id, value) => {
        let error = "";
        const trimmed = typeof value === "string" ? value.trim() : value;
        switch (id) {
            case "start":
                if (!trimmed) {
                    error = "Start date is required";
                }
                break;

            case "end":
                if (!trimmed) {
                    error = "End date is required";
                }
                break;

            default:
                break;
        }

        setErrors((prev) => ({...prev, [id]: error}));
        return error === "";
    };

    const handleBlur = (e) => {
        const {id, value} = e.target;
        validateField(id, value);
    };

    const validateForm = () => {
        let isValid = true;
        Object.entries(formData).forEach(([key, value]) => {
            const valid = validateField(key, value);
            if (!valid) isValid = false;
        });
        return isValid;
    };

    const handleFormChange = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const isFormValid = validateForm();

        if (!isFormValid) return;
        dispatch(fetchCustomerPayments({...userRole, customer: params.customerId, formData}));
    };

    //Set search query to last month
    useEffect(() => {
        if (dateRange?.start && dateRange?.end) {
            setFormData({
                start: dateRange.start.slice(0, 10),
                end: dateRange.end.slice(0, 10),
            });
        }
    }, [dateRange?.start, dateRange?.end]);

    useEffect(() => {
        dispatch(
            fetchCustomerPayments({
                ...userRole,
                customer: params.customerId,
            })
        );
    }, [dispatch, params.customerId, userRole]);

    return (
        <>
            <SubHeader title={`Transaction - ${fromCamelCaseToTitle(params.customer)}`}>
                <Button
                    to={`/customer/${params.customerId}/customerOrder`}
                    className="btn-sm bg-secondary bg-opacity-50"
                >
                    Back
                </Button>
            </SubHeader>

            {fetchCustomerPaymentStatus === "loading" && <p>Loading...</p>}
            {fetchCustomerPaymentStatus === "failed" && (
                <h6 className="text-danger">{error}</h6>
            )}

            {fetchCustomerPaymentStatus === "success" && (
                <>
                    <form onSubmit={handleSubmit}>
                        <div className="row mb-5">
                            <div className="col-md-4 col-lg-2">
                                <div className="form-group">
                                    <label className="form-label opacity-75 mb-0">Start Date</label>
                                    <input
                                        className="form-control"
                                        id="start"
                                        name="start"
                                        type="date"
                                        onBlur={handleBlur}
                                        value={formData.start}
                                        onChange={(e) => handleFormChange("start", e.target.value)}
                                    />
                                    {errors.start &&
                                        <div className="invalid-feedback d-block">{errors.start}</div>}
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-2">
                                <div className="form-group">
                                    <label className="form-label opacity-75 mb-0">End Date</label>
                                    <input
                                        className="form-control"
                                        id="end"
                                        name="end"
                                        type="date"
                                        onBlur={handleBlur}
                                        value={formData.end}
                                        onChange={(e) => handleFormChange("end", e.target.value)}
                                    />
                                    {errors.end &&
                                        <div className="invalid-feedback d-block">{errors.end}</div>}
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-2">
                                <div className="form-group">
                                    <label className="form-label opacity-75 d-block mb-0 mt-1">&nbsp;</label>
                                    <button type="submit"
                                            className="btn bg-primary bg-opacity-15 bg-opacity-25-hover py-2 px-4 fw-medium border-0 me-2 fs-sm">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="row">
                        <div className="col-md-8">
                            {customerPayments.map((item, index) => (
                                <CustomerTransactionCard key={index} item={item}/>
                            ))}
                        </div>
                        {customerPayments.length === 0 && <p>No data to show.</p>}
                    </div>
                </>
            )}
        </>
    );
};

export default CustomerTransactions;
